import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  // Accordion,
  // AccordionDetails,
  // AccordionSummary,
  Box,
  Button,
  Divider,
  Grid,
  Link,
  Typography,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { Container } from '@mui/system';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

// FIX 1: Dynamically import heavy libraries to reduce TBT
const Countdown = dynamic(() => import('react-countdown'), { ssr: false });
import CardForms from '@/components/home/card-forms';
import Hero from '@/components/home/hero';
import AutoTextLoop from '@/components/ui/AutoTextLoop';
// import Popup2290 from '@/components/ui/2290Popup';
import BlogContent from '@/components/ui/BlogContent';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';
import { getLastDateOfTheMonth } from '@/utils/utils';

const layoutWrapperContents: LayoutWrapperContents = {
  Heading: 'Missed e-filing Form 2290 for the 2023 tax year?',
  SubHeading: '$19.99',
  CtaText: 'E-file Form 2290 Now',
  CtaSubHeading: `Schedule 1`,
  CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290sticky`,
  isActive: false,
};

const Index = () => {
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());
  // FIX 2: YouTube facade state — avoids loading iframe until user clicks
  const [showVideo, setShowVideo] = useState(false);

  // FIX 3: Remove setInterval — Countdown component handles its own ticking
  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 5, 15));
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <>
      <AppLayout
        LayoutWrapperContents={layoutWrapperContents}
        meta={
          <Meta
            title="E-Filing IRS Tax Forms Simplified with TaxZerone®"
            description="Effortless e-filing for IRS excise, employment, business, nonprofit, and extension forms. Simplify tax compliance with our secure online service for all users."
            keywords="form 7004, form 4868, form 8868, form 990N, form 2290, Form 990, Form 941, efile irs forms, irs forms, irs extension form, authorized IRS e-file provider, excise tax, 990-n e-postcard, HVUT, Employment Tax, Payroll Tax"
            canonical=""
          />
        }
      >
        {/* <Popup2290 /> */}
        <Box
          sx={{
            position: 'sticky',
            mt: 0,
            mb: -1,
            top: 64,
            zIndex: 11,
            background: 'linear-gradient(to right, #390099, #9e0059  )',
            minHeight: 48,
            height: { xs: 'auto', sm: 'auto', md: 52 },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          component="section"
        >
          <Container
            sx={{
              position: 'relative',
              mt: 0,
              mb: 0,
            }}
            maxWidth="lg"
          >
            <AutoTextLoop />
            <Countdown date={lastDayTaxSeason} renderer={renderer} />
          </Container>
        </Box>
        <Hero />

        <Box
          sx={{
            backgroundColor: '#f0f2f9',
            mx: '0 !important',
            width: '100% !important',
            backgroundPosition: 'center bottom',
            py: 3,
          }}
          component="section"
        >
          <CardForms />
        </Box>
        <Box
          sx={{
            backgroundColor: '#1da94a',
            py: { lg: 8, md: 8, sm: 4, xs: 4 },
            mx: '0 !important',
            width: '100% !important',
            mb: 0,
            p: 2,
            textAlign: 'center',
          }}
          m={2}
          mt={0}
          className="curve-bg"
          component="section"
        >
          <Container maxWidth="md">
            <Typography
              variant="h2"
              color="white"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                lineHeight: 1.3,
                mb: 3,
              }}
            >
              Ready to experience the ease and convenience of filing your IRS
              forms with TaxZerone?
            </Typography>

            <Typography
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                lineHeight: 1.5,
                color: '#f3f3f3',
                mb: 3,
              }}
            >
              Simplify IRS form filing and ensure that your forms are filed
              accurately and on time. Sign up now and enjoy a hassle-free filing
              experience!
            </Typography>
            <Box component="div" sx={{ margin: 'auto' }}>
              <Button
                variant="contained"
                sx={{
                  mt: { xs: 0, sm: 4 },
                  mb: { xs: 0, md: 0 },
                  color: '#444',
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &active': {
                    backgroundColor: '#213e99 !important',
                    color: '#fff',
                    transform: 'scale(1.1)',
                  },
                }}
                className="btn-secondary-white"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=main`}
              >
                Sign Up For&nbsp;<b>FREE</b>
              </Button>
              <Typography variant="body2" sx={{ mt: 2, color: '#f3f3f3' }}>
                Explore our{' '}
                <Link href="/resources/" sx={{ color: '#f9ff69' }}>
                  {' '}
                  Resource Center
                </Link>{' '}
                to find complete instructions and due dates for all IRS tax
                forms
              </Typography>
            </Box>
          </Container>
        </Box>

        <Grid
          container
          sx={{
            backgroundColor: '#f0f2f9',
            mx: '0 !important',
            width: '100% !important',
          }}
          spacing={2}
          m={0}
          className="dotted-curve"
          component="section"
          aria-labelledby="advanced-features"
        >
          <Container maxWidth="lg" sx={{ mb: 5, textAlign: 'center' }}>
            <Typography
              variant="h2"
              id="advanced-features"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.3,
                mt: 8,
              }}
            >
              Simplify Your Filing Process with TaxZerone&apos;s
              <Hidden smDown>
                <br />
              </Hidden>{' '}
              Advanced Features
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 5,
                textAlign: 'center',
              }}
            >
              Complete your IRS forms without any hassles with the help of these
              advanced features.
            </Typography>
            <Grid
              container
              spacing={2}
              m={2}
              mt={4}
              pb={{ xs: 0, md: 3 }}
              sx={{ justifyContent: 'center', px: 0, listStyleType: 'none' }}
              component="ul"
            >
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#8492c0',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: { xs: '#fff', sm: '#efefef' },
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/form-based-icon.webp" />
                      <source srcSet="/assets/images/form-based-icon.png" />
                      <img
                        src="/assets/images/form-based-icon.png"
                        alt="Form-Based Filing"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Form-Based Filing
                  </Typography>
                  <Typography variant="body1">
                    Our form-based filing interface ensures you complete all the
                    necessary fields in less time.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#76ce97',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                    mt: { xs: 0, md: 4 },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: { xs: '#fff', sm: '#efefef' },
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/irs-rule-icon.webp" />
                      <source srcSet="/assets/images/irs-rule-icon.png" />
                      <img
                        src="/assets/images/irs-rule-icon.png"
                        alt="IRS Form Validation"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    IRS Form Validation
                  </Typography>
                  <Typography variant="body1">
                    Our system checks your forms for errors and missing
                    information based on IRS rules, reducing the risk of
                    rejection.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#8492c0',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: { xs: '#fff', sm: '#efefef' },
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/address-book-icon.webp" />
                      <source srcSet="/assets/images/address-book-icon.png" />
                      <img
                        src="/assets/images/address-book-icon.png"
                        alt="Address Book"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Address Book
                  </Typography>
                  <Typography variant="body1">
                    Your business and form information is stored securely for
                    future use, ensuring quick and easy filing next time.
                  </Typography>
                </Paper>
              </Grid>
              <Hidden mdDown>
                <Grid size={12} component="li">
                  &nbsp;
                </Grid>
              </Hidden>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#76ce97',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                    mt: { xs: 0, md: 4 },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: { xs: '#fff', sm: '#efefef' },
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/forms-history-icon.webp" />
                      <source srcSet="/assets/images/forms-history-icon.png" />
                      <img
                        src="/assets/images/forms-history-icon.png"
                        alt="Forms History"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Forms History
                  </Typography>
                  <Typography variant="body1">
                    Access your previous forms filed with TaxZerone easily so
                    that you can track your filing history.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#8492c0',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: { xs: '#fff', sm: '#efefef' },
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/free-efile-retransmission-icon.webp" />
                      <source srcSet="/assets/images/free-efile-retransmission-icon.png" />
                      <img
                        src="/assets/images/free-efile-retransmission-icon.png"
                        alt="Free Retransmission"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Free Retransmission
                  </Typography>
                  <Typography variant="body1">
                    If your return is rejected, we offer free retransmission, so
                    you can quickly fix any issues and resubmit at no additional
                    cost.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#76ce97',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                    mt: { xs: 0, md: 4 },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: { xs: '#fff', sm: '#efefef' },
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/secure-icon.webp" />
                      <source srcSet="/assets/images/secure-icon.png" />
                      <img
                        src="/assets/images/secure-icon.png"
                        alt="Complete Security"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Complete Security
                  </Typography>
                  <Typography variant="body1">
                    We take security seriously and protect your personal and
                    financial information with the latest encryption technology.
                  </Typography>
                </Paper>
              </Grid>
              <Hidden mdDown>
                <Grid size={12} component="li">
                  &nbsp;
                </Grid>
              </Hidden>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#8492c0',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#efefef',
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/irs-icon.webp" />
                      <source srcSet="/assets/images/irs-icon.png" />
                      <img
                        src="/assets/images/irs-icon.png"
                        alt="E-File Center for Efficient Tax Filings"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    E-File Center for Efficient Tax Filings
                  </Typography>
                  <Typography variant="body1">
                    Centralized location for managing all your tax filings.
                    Manage tax returns filed with the IRS with ease, ensuring
                    accuracy and compliance at every step.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#76ce97',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                    mt: { xs: 0, md: 4 },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#efefef',
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/upload-icon.webp" />
                      <source srcSet="/assets/images/upload-icon.png" />
                      <img
                        src="/assets/images/upload-icon.png"
                        alt="Bulk Upload Options"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Bulk Upload Options
                  </Typography>
                  <Typography variant="body1">
                    Save time by uploading multiple tax return info in one go.
                    Quickly import and process large batches of tax return data,
                    reduce manual effort significantly, and increase
                    productivity.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 3,
                    borderColor: '#8492c0',
                    borderRadius: 10,
                    minHeight: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: { xs: '#fff', sm: '#efefef' },
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source srcSet="/assets/images/multi-user-icon.webp" />
                      <source srcSet="/assets/images/multi-user-icon.png" />
                      <img
                        src="/assets/images/multi-user-icon.png"
                        alt="Multi-user support"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Multi-user support
                  </Typography>
                  <Typography variant="body1">
                    Add various roles with different permissions to handle your
                    filings. Allow one person to create a return, another to
                    review it, and a third person to approve it for filing.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
            <Typography
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                mt: 5,
                textAlign: 'center',
              }}
            >
              Try TaxZerone today and experience the ease of filing your IRS
              forms.
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 4,
                mx: 'auto',
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=main`}
            >
              E-File Now
            </Button>
            <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
              Simple. Quick. Accurate.
            </Typography>
          </Container>
        </Grid>
        <Box
          sx={{
            backgroundColor: '#fff',
            mx: '0 !important',
            width: '100% !important',
          }}
          m={0}
          component="section"
          aria-labelledby="filing-process"
        >
          <Container maxWidth="lg">
            <Grid
              container
              spacing={2}
              sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
              className="MuiGrid-root-width"
            >
              <Grid size={12} textAlign="center">
                <Typography
                  variant="h2"
                  id="filing-process"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'center',
                    lineHeight: 1.3,
                  }}
                >
                  Easy as 1-2-3: Filing IRS Forms Made{' '}
                  <Hidden smDown>
                    <br />
                  </Hidden>
                  Simple with TaxZerone
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Three simple steps to file your IRS forms easily and
                  confidently.
                </Typography>
              </Grid>
            </Grid>
          </Container>

          <Container maxWidth="xl" sx={{ mb: 5 }}>
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={{ xs: 2, md: 5 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                  mt: { xs: -3, md: -5, lg: -8 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/main-dashboard-img.webp" />
                  <source srcSet="/assets/images/main-dashboard-img.png" />
                  <img
                    src="/assets/images/main-dashboard-img.png"
                    alt="Easy as 1-2-3: Filing IRS Forms Made Simple with TaxZerone"
                    className="img-responsive"
                    loading="lazy"
                    width={915}
                    height={790}
                  />
                </picture>
              </Box>

              <Box sx={{ width: '100%' }}>
                <Box
                  component="ol"
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                    p: 2,
                    pl: 0,
                    ml: { xs: 0, sm: 0, md: -2 },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          my: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-1-icon.webp" />
                          <source srcSet="/assets/images/step-1-icon.png" />
                          <img
                            src="/assets/images/step-1-icon.png"
                            alt="Select the Form"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        Select the Form
                      </Typography>
                      <Typography variant="body1">
                        Choose the form you need to file from our list of
                        Extension, Excise truck tax, Nonprofit forms, Employment
                        Tax and Information Returns.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          m: 0,
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-2-icon.webp" />
                          <source srcSet="/assets/images/step-2-icon.png" />
                          <img
                            src="/assets/images/step-2-icon.png"
                            alt="Fill Out the Form"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        Fill Out the Form
                      </Typography>
                      <Typography variant="body1">
                        Enter your information on the form, and we'll ensure you
                        complete all the required fields accurately.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-3-icon.webp" />
                          <source srcSet="/assets/images/step-3-icon.png" />
                          <img
                            src="/assets/images/step-3-icon.png"
                            alt="Transmit the Form"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        Transmit the Form
                      </Typography>
                      <Typography variant="body1">
                        Once you&apos;ve completed the form, simply transmit it
                        to the IRS securely and quickly.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 21, md: 20, sm: 18, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    textAlign: { xs: 'center', md: 'left' },
                  }}
                >
                  Hassle-free steps to complete your IRS form filing. Try it
                  yourself.
                </Typography>
                <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                  <Button
                    variant="contained"
                    sx={{
                      mt: { xs: 2, sm: 4 },
                      mb: { xs: 2, sm: 2, md: 5 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=main`}
                  >
                    E-file Now
                  </Button>
                </Box>
              </Box>
            </Stack>
          </Container>
        </Box>
        <Grid
          container
          sx={{
            backgroundColor: '#f0f2f9',
            mx: '0 !important',
            width: '100% !important',
            py: { xs: 1, sm: 3 },
          }}
          spacing={2}
          m={0}
          component="section"
        >
          <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.3,
                mt: 5,
              }}
            >
              Choose TaxZerone for Seamless IRS Form Filing and
              <Hidden smDown>
                <br />
              </Hidden>{' '}
              Real-time Updates
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
                textAlign: 'center',
              }}
            >
              Here are the top 3 reasons to choose TaxZerone to e-file your IRS
              forms.
            </Typography>
            <Grid
              container
              spacing={2}
              m={2}
              pb={2}
              className="MuiGrid-root-width"
              sx={{ justifyContent: 'center', p: 0, listStyleType: 'none' }}
              component="ul"
            >
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 10,
                    height: '100%',
                    boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#1da94a',
                      borderRadius: '50%',
                      width: 96,
                      height: 96,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 62, height: 54 }}>
                      <source srcSet="/assets/images/easy-white-icon.webp" />
                      <source srcSet="/assets/images/easy-white-icon.png" />
                      <img
                        src="/assets/images/easy-white-icon.png"
                        alt="Easy E-Filing"
                        loading="lazy"
                        width={62}
                        height={54}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Easy E-Filing
                  </Typography>
                  <Typography variant="body1">
                    We offer a user-friendly e-filing process that ensures you
                    don&apos;t miss any crucial information. Our step-by-step
                    approach makes filing your IRS forms a breeze.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 10,
                    height: '100%',
                    boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#1da94a',
                      borderRadius: '50%',
                      width: 96,
                      height: 96,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 62, height: 54 }}>
                      <source srcSet="/assets/images/irs-white-icon.webp" />
                      <source srcSet="/assets/images/irs-white-icon.png" />
                      <img
                        src="/assets/images/irs-white-icon.png"
                        alt="IRS Authorized"
                        loading="lazy"
                        width={62}
                        height={54}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    IRS Authorized
                  </Typography>
                  <Typography variant="body1">
                    TaxZerone is an authorized e-file service provider, so you
                    can trust us to file your forms accurately and securely.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
                <Paper
                  variant="outlined"
                  sx={{
                    px: 3,
                    pt: { xs: 2, sm: 5 },
                    pb: { xs: 2, sm: 5 },
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 10,
                    height: '100%',
                    boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#1da94a',
                      borderRadius: '50%',
                      width: 96,
                      height: 96,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 62, height: 54 }}>
                      <source srcSet="/assets/images/time-white-icon.webp" />
                      <source srcSet="/assets/images/time-white-icon.png" />
                      <img
                        src="/assets/images/time-white-icon.png"
                        alt="Real-Time Updates"
                        loading="lazy"
                        width={62}
                        height={54}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                    }}
                  >
                    Real-Time Updates
                  </Typography>
                  <Typography variant="body1">
                    With TaxZerone, you&apos;ll receive real-time updates on the
                    status of your return, so you always know where you stand.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
            <Typography
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                lineHeight: 1.5,
                mt: 5,
              }}
            >
              Our simple and secure e-filing process saves you time and
              <Hidden smDown>
                <br />
              </Hidden>{' '}
              effort so that you can focus on other things.
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 4,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=main`}
            >
              E-File Now
            </Button>
            <Typography variant="body2" sx={{ mt: 1, mb: 3 }}>
              Simple. Quick. Accurate.
            </Typography>
          </Container>
        </Grid>

        <Grid
          container
          sx={{
            py: { lg: 8, md: 8, sm: 4, xs: 4 },
            mx: '0 !important',
            mb: '0 !important',
            width: '100% !important',
          }}
          spacing={2}
          m={2}
          mt={0}
          component="section"
        >
          <Container maxWidth="xl">
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 22, xs: 20 },
                  fontWeight: 600,
                  lineHeight: 1.3,
                  mb: 3,
                }}
              >
                Meet Zee — Your Smart Tax Filing Guide
              </Typography>
              <Box
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  textAlign: 'center',
                }}
              >
                {/* FIX 9: YouTube facade — load thumbnail first, iframe only on click */}
                {showVideo ? (
                  <Box
                    component="iframe"
                    title="Simplify Your IRS Tax E-Filing with TaxZerone.com"
                    src="https://www.youtube.com/embed/vRTe9IGJBxo?autoplay=1&rel=0"
                    sx={{
                      width: { xs: '100%', sm: 640, md: 780, lg: 980 },
                      height: { xs: 210, sm: 371, md: 452, lg: 568 },
                      border: '10px solid #333 !important',
                      borderRadius: 5,
                    }}
                    allowFullScreen={true}
                  />
                ) : (
                  <Box
                    onClick={() => setShowVideo(true)}
                    role="button"
                    aria-label="Play TaxZerone video"
                    sx={{
                      cursor: 'pointer',
                      position: 'relative',
                      display: 'inline-block',
                      width: { xs: '100%', sm: 640, md: 780, lg: 980 },
                      height: { xs: 210, sm: 371, md: 452, lg: 568 },
                      border: '10px solid #333',
                      borderRadius: 5,
                      overflow: 'hidden',
                      backgroundColor: '#000',
                    }}
                  >
                    <Box
                      component="img"
                      src="https://i.ytimg.com/vi/vRTe9IGJBxo/hqdefault.jpg"
                      alt="TaxZerone — Your Smart Tax Filing Guide video thumbnail"
                      width={640}
                      height={360}
                      loading="lazy"
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        opacity: 0.85,
                      }}
                    />
                    {/* YouTube play button */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 68,
                        height: 48,
                        backgroundColor: '#ff0000',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '&:hover': { backgroundColor: '#cc0000' },
                        transition: 'background-color 0.2s',
                      }}
                    >
                      <Box
                        sx={{
                          width: 0,
                          height: 0,
                          borderTop: '10px solid transparent',
                          borderBottom: '10px solid transparent',
                          borderLeft: '20px solid white',
                          ml: '4px',
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
              <Box component="div" sx={{ margin: 'auto' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: { xs: 0, sm: 4 },
                    mb: { xs: 1, md: 0 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=main`}
                >
                  Start the&nbsp;<b>Zee Experience</b>
                </Button>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Watch how Zee makes tax filing simple, fast, and stress-free.
                </Typography>
              </Box>
            </Grid>
          </Container>
        </Grid>
        <Grid
          container
          sx={{
            backgroundColor: '#f0f2f9',
            mx: '0 !important',
            width: '100% !important',
            backgroundPosition: 'center bottom',
          }}
          spacing={2}
          m={0}
          component="section"
        >
          <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
            <Grid
              container
              spacing={2}
              m={2}
              mt={{ xs: 5, sm: 5, md: 6 }}
              mb={{ xs: 5, sm: 5, md: 8 }}
              className="MuiGrid-root-width"
            >
              <Grid size={12} textAlign="center">
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ mb: 2 }}
                  justifyContent={{ xs: 'center', md: 'center' }}
                >
                  <img
                    src="/assets/images/star-icon.svg"
                    width={30}
                    height={28}
                    alt="star-1"
                  />
                  <img
                    src="/assets/images/star-icon.svg"
                    width={30}
                    height={28}
                    alt="star-2"
                  />
                  <img
                    src="/assets/images/star-icon.svg"
                    width={30}
                    height={28}
                    alt="star-3"
                  />
                  <img
                    src="/assets/images/star-icon.svg"
                    width={30}
                    height={28}
                    alt="star-4"
                  />
                  <img
                    src="/assets/images/star-icon.svg"
                    width={30}
                    height={28}
                    alt="star-5"
                  />
                </Stack>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: { xs: 1, sm: 3 },
                  }}
                >
                  Hear what our customers have to say about us
                </Typography>
                <Grid
                  container
                  spacing={2}
                  m={0}
                  justifyContent="center"
                  direction="row"
                  className="MuiGrid-root-width"
                >
                  {[
                    'TaxZerone is the best e-file service I have ever used. The interface is user-friendly, and the step-by-step instructions make the process easy to follow.',
                    "I'm so glad I found TaxZerone! Filing Form 7004 for my business has always been a headache, but TaxZerone makes it so much easier.",
                    'I was skeptical at first about using an e-file service for my personal tax extension, but TaxZerone exceeded my expectations. The process was straightforward and seamless.',
                    'TaxZerone is a lifesaver! The step-by-step instructions were so easy to follow, and I received my approval letter immediately.',
                    'The interface is intuitive and easy to navigate. Plus, their customer service team is always available to help with any questions or concerns. I highly recommend TaxZerone!',
                    'I just wanted to take a moment to express what a great conversation I had with the support agent via the chat platform. He was very attentive and resolved my issue. Also, very patient and kind! Excellent service!',
                  ].map((quote, index) => (
                    <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
                      <Paper
                        elevation={0}
                        sx={{
                          background: '#fff',
                          p: 2,
                          borderRadius: 3,
                          minHeight: '100%',
                        }}
                      >
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ my: 1 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontFamily: 'san-serif',
                              fontSize: { xs: 45, sm: 65 },
                              fontWeight: 600,
                              lineHeight: { xs: '30px', sm: '65px' },
                              color: '#999',
                            }}
                          >
                            &ldquo;
                          </Typography>
                          <Typography
                            component="div"
                            variant="body1"
                            sx={{
                              fontSize: { xs: 16, sm: 18, md: 20 },
                              fontFamily: 'san-serif',
                              fontStyle: 'italic',
                              color: '#414042',
                              lineHeight: 1.2,
                            }}
                          >
                            {quote}{' '}
                            <Stack
                              direction="row"
                              spacing={1}
                              sx={{ mt: 2 }}
                              justifyContent={{ xs: 'center', md: 'center' }}
                            >
                              {[1, 2, 3, 4, 5].map((s) => (
                                <img
                                  key={s}
                                  src="/assets/images/star-icon.svg"
                                  width={18}
                                  height={17}
                                  alt={`star-${s}`}
                                />
                              ))}
                            </Stack>
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              fontFamily: 'san-serif',
                              fontSize: { xs: 45, sm: 65 },
                              fontWeight: 600,
                              lineHeight: { xs: '30px', sm: '65px' },
                              color: '#999',
                            }}
                          >
                            &rdquo;
                          </Typography>
                        </Stack>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Grid>

        <Box
          sx={{
            pt: { lg: 0, md: 0, sm: 0, xs: 2 },
            pb: { lg: 4, md: 4, sm: 4, xs: 4 },
            mx: '0 !important',
            mb: '0 !important',
            width: '100% !important',
          }}
          m={2}
          mt={0}
          component="section"
          aria-labelledby="faq-heading"
        >
          <Container maxWidth="lg">
            <Grid
              container
              spacing={2}
              m={2}
              direction="row"
              justifyContent="center"
              className="MuiGrid-root-width"
              sx={{ my: { xs: 0, sm: 0 } }}
            >
              <Grid
                size={{ xs: 12, sm: 10, md: 9 }}
                textAlign="left"
                my={{ xs: 2, sm: 5 }}
                mb={3}
              >
                <Typography
                  variant="h2"
                  id="faq-heading"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 5,
                    textAlign: 'center',
                    lineHeight: 1.3,
                  }}
                >
                  FAQs
                </Typography>
                <Box
                  // component={'article'}
                  sx={{ mb: 5 }}
                  itemScope
                  itemType="https://schema.org/FAQPage"
                >
                  <Box
                    component="article"
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                    sx={{
                      border: '1px solid rgba(145, 158, 171, 0.35)',
                      p: 2,
                      mb: 2,
                      backgroundColor: '#fff',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        color: '#36324a',
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                      itemProp="name"
                    >
                      Why should I e-file IRS tax forms?
                    </Typography>

                    <Box
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <Typography itemProp="text">
                        E-filing IRS tax forms offers several benefits, such as
                        faster processing, reduced errors with built-in checks,
                        secure transmission of personal information, convenient
                        payment choices, and, of course, environmentally
                        friendly compared to paper filing.
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    component="article"
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                    sx={{
                      border: '1px solid rgba(145, 158, 171, 0.35)',
                      p: 2,
                      mb: 2,
                      backgroundColor: '#fff',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        color: '#36324a',
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                      itemProp="name"
                    >
                      How does TaxZerone simplify e-filing?
                    </Typography>

                    <Box
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <Typography itemProp="text">
                        TaxZerone simplifies e-filing as it was started by a
                        team of tax experts with over a decade of experience in
                        IRS tax filing. Our mission is to make the process
                        simple, quick, and accurate. For any IRS form we
                        support, the filing process involves just three easy
                        steps, taking only a few minutes to complete.
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    component="article"
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                    sx={{
                      border: '1px solid rgba(145, 158, 171, 0.35)',
                      p: 2,
                      mb: 2,
                      backgroundColor: '#fff',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        color: '#36324a',
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                      itemProp="name"
                    >
                      {/* 3. What are the forms supported by TaxZerone? */}
                      What IRS tax forms can I e-file with TaxZerone?
                    </Typography>

                    <Box
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <Box itemProp="text">
                        <Typography variant="body1">
                          TaxZerone supports multiple IRS tax forms under seven
                          different categories, and they are as follows:
                        </Typography>
                        <ul>
                          <li>Excise tax forms</li>
                          <li>Exempt Organization Forms</li>
                          <li>Employment Tax Forms</li>
                          <li>Extension Forms</li>
                          <li>Business Tax Forms</li>
                          <li>Information returns</li>
                          <li>Essential Forms</li>
                        </ul>
                      </Box>
                    </Box>
                  </Box>
                  <Box
                    component="article"
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                    sx={{
                      border: '1px solid rgba(145, 158, 171, 0.35)',
                      p: 2,
                      mb: 2,
                      backgroundColor: '#fff',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        color: '#36324a',
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                      itemProp="name"
                    >
                      Does TaxZerone support e-filing for tax professionals?
                    </Typography>

                    <Box
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <Typography itemProp="text">
                        TaxZerone provides a wide range of features that aim to
                        streamline your tax preparation and filing process. Our
                        platform enables you to deliver exceptional service to
                        your clients with ease.
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    component="article"
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                    sx={{
                      border: '1px solid rgba(145, 158, 171, 0.35)',
                      p: 2,
                      mb: 2,
                      backgroundColor: '#fff',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        color: '#36324a',
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                      itemProp="name"
                    >
                      How much does it cost to file IRS tax returns?
                    </Typography>

                    <Box
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <Typography itemProp="text">
                        TaxZerone offers affordable pricing for all the
                        supported IRS forms. You can check out our{' '}
                        <Link href="/pricing/" sx={{ color: '#0202ff' }}>
                          pricing
                        </Link>{' '}
                        page for more information.
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    component="article"
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                    sx={{
                      border: '1px solid rgba(145, 158, 171, 0.35)',
                      p: 2,
                      mb: 2,
                      backgroundColor: '#fff',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        color: '#36324a',
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                      itemProp="name"
                    >
                      Does TaxZerone support IRS Form 15397?
                    </Typography>

                    <Box
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <Typography itemProp="text">
                        <span style={{ fontWeight: 600 }}> Yes.</span> TaxZerone
                        supports{' '}
                        <Link
                          href="/tax-extension/file-irs-form-15397-online/"
                          sx={{ color: '#0202ff' }}
                        >
                          IRS Form 15397
                        </Link>
                        , allowing you to request a{' '}
                        <span style={{ fontWeight: 600 }}>
                          one-time 30-day extension
                        </span>{' '}
                        to furnish recipient statements such as W-2, 1099, 1095,
                        1042-S, and other supported forms. You can prepare
                        accurate extension requests, manage issuer details, and
                        stay compliant with IRS deadlines, all from one secure,
                        easy-to-use platform designed for U.S. businesses and
                        filers.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ textAlign: 'center', mt: 3 }}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="large"
                    sx={{
                      borderWidth: 2,
                      borderRadius: 3,
                      textTransform: 'none',
                      '&:hover, &:focus, &:active': { borderWidth: 2 },
                    }}
                    href="/faqs/"
                  >
                    More FAQs
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <Divider sx={{ mt: 2, mb: { xs: 2, sm: 4 } }} />
          </Container>
          <Container maxWidth="lg" sx={{ mb: { xs: 3, sm: 5 } }}>
            <Grid
              container
              spacing={2}
              m={0}
              pb={0}
              className="MuiGrid-root-width"
            >
              <Grid size={12} textAlign="center">
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: { xs: 0, sm: 3 },
                    textAlign: 'center',
                    lineHeight: 1.3,
                    mt: 0,
                  }}
                >
                  Recent Resources
                </Typography>
              </Grid>
              <Grid size={{ md: 4, sm: 4, xs: 12 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignContent: 'center',
                    borderRadius: 4,
                    p: 3,
                    minHeight: '100%',
                    backgroundColor: '#f0f2f9',
                    transition: 'all 0.3s ease 0s',
                  }}
                >
                  <Typography variant="body1">
                    <Link
                      href="/resources/tax-exempt/form-ftb-3509-guide/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form FTB 3509
                    </Link>{' '}
                    - Political or Legislative Activities
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ md: 4, sm: 4, xs: 12 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignContent: 'center',
                    borderRadius: 4,
                    p: 3,
                    minHeight: '100%',
                    backgroundColor: '#f0f2f9',
                    transition: 'all 0.3s ease 0s',
                  }}
                >
                  <Typography variant="body1">
                    <Link
                      href="/resources/tax-exempt/ftb-form-3885/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form FTB 3885
                    </Link>{' '}
                    - Corporation Depreciation and Amortization
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ md: 4, sm: 4, xs: 12 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignContent: 'center',
                    borderRadius: 4,
                    p: 3,
                    minHeight: '100%',
                    backgroundColor: '#f0f2f9',
                    transition: 'all 0.3s ease 0s',
                  }}
                >
                  <Typography variant="body1">
                    <Link
                      href="/resources/tax-exempt/ftb-form-3885f-depreciation/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form FTB 3885F
                    </Link>{' '}
                    - Depreciation and Amortization
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Box
          sx={{ backgroundColor: '#f0f2f9', pt: 5, pb: 5 }}
          component="section"
        >
          <Container maxWidth="lg" sx={{ mb: { xs: 3, sm: 5 } }}>
            <Grid
              container
              spacing={2}
              m={0}
              pb={0}
              className="MuiGrid-root-width"
            >
              <Grid size={12} textAlign="center">
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: { xs: 0, sm: 3 },
                    textAlign: 'center',
                    lineHeight: 1.3,
                    mt: 0,
                  }}
                >
                  Recent Blogs
                </Typography>
              </Grid>

              <BlogContent />
            </Grid>
          </Container>
        </Box>
      </AppLayout>
    </>
  );
};

export default Index;
